import axios from 'axios';

const server = process.env.REACT_APP_SERVER_URL;

export interface Movimiento {
  // Campos base (todos los tipos)
  id_procedimiento?: number;
  fecha_movimiento: string;
  tipo_movimiento: string;
  descripcion?: string | null;
  nombre_completo?: string;
  cedula?: string;
  nacionalidad?: string;
  direccion?: string | null;
  // Campos adicionales para 'Aprobar pago'
  id_pago?: number;
  monto?: number;
  aprobado?: boolean;
  banco_origen?: string;
  banco_destino?: string;
  referencia?: string;
  fecha_de_pago?: string;
  fecha_de_aprobacion?: string;
  concepto_pago?: string;
  metodo_pago?: string;
  // Campos enriquecidos para 'Aprobar pago' y 'actualizando datos de liquidacion'
  id_solicitud?: number;
  documento?: string;
  razon_social?: string;
  // Campos adicionales para 'liquidacion borrada'
  concepto?: string;
  usuario?: {
    id: number;
    nombre_completo: string;
    nombre_usuario: string;
  };
  detalle?: {
    id_solicitud: number;
    documento: string;
    razon_social: string;
  };
  payload?: {
    id_liquidacion: number;
    usuario: string;
    contribuyente: {
      tipo_documento: string;
      documento: string;
      razon_social: string;
    };
    liquidacion: {
      monto: number;
      fecha_liquidacion: string;
    };
  };
}

export interface MovimientosResponse {
  movimientos: Movimiento[];
  pagesTotal: number;
  totalRows: number;
}

interface ApiResponse {
  status: number;
  message: string;
  movimientos: Movimiento[];
  pagesTotal: number;
  totalRows: number;
}

export const getMovements = async (
  tipoMovimiento: string,
  page: number = 1,
  token: string
): Promise<MovimientosResponse> => {
  try {
    const encodedTipo = encodeURIComponent(tipoMovimiento);
    const response = await axios.get<ApiResponse>(
      `${server}/movements/${encodedTipo}/${page}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return {
      movimientos: response.data.movimientos,
      pagesTotal: response.data.pagesTotal,
      totalRows: response.data.totalRows,
    };
  } catch (error) {
    throw error;
  }
};
